module.exports = __webpack_public_path__ + "img/scm개념도.0aca7fe7.png";